import { makeStyles } from 'tss-react/mui';

// Styles
import { colors } from '../../../../styles/palette';

export const useStyles = makeStyles()((theme) => ({
  accent: { color: colors.gilead.primary1 },
  radioGroup: {
    marginBottom: theme.spacing(4),
    [theme.breakpoints.down('lg')]: {
      marginBottom: theme.spacing(3),
    },
    [theme.breakpoints.down('md')]: {
      marginBottom: theme.spacing(1.5),
    },
  },
  radioLabel: {
    width: 'fit-content',
    '& .MuiTypography-root': {
      fontSize: 18,
      [theme.breakpoints.down('md')]: {
        fontSize: 16,
      },
    },
  },
  radioItem: {
    color: '#C6CAC6',
    padding: 8,
    '&$checked': { color: theme.palette.primary1 },
    [theme.breakpoints.down('md')]: {
      padding: 5,
    },
  },
  buttons: {
    paddingBottom: 0,
    '& #accept-button': {
      [theme.breakpoints.down('lg')]: {
        width: 110,
      },
      [theme.breakpoints.down('md')]: {
        width: 140,
        height: 44,
      },
    },
  },
}));
